import { Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-account-created',
  templateUrl: './account-created.component.html',
  styleUrls: ['./account-created.component.css']
})
export class AccountCreatedComponent {
  @Input() public originalUrl?: string;

  constructor(private activatedActivated: ActivatedRoute) {}

  show_button = this.activatedActivated.snapshot.queryParams['mode'] !== 'idp';
}
